import React, { useEffect, useContext, useState, useCallback } from "react";
import { AuthContext } from "../../services/Authentication";
import ConversationSearch from "../../components/conversation/conversation-search/ConversationSearch";
import NoConversations from "../../components/conversation/no-conversations/NoConversations";
import ConversationList from "../../components/conversation/conversation-list/ConversationList";
import app from "../../services/base";
import ChatTitle from "../../components/chat-title/ChatTitle";
import MessageList from "../message/MessageList";
import ChatForm from "../../components/chat-form/ChatForm";
import ChatBio from "../../components/chat-bio/ChatBio";
import Dashboard from "../../components/Dashboard/Dashboard";
import "./ChatShell.scss";
import { generateUniqueFirestoreId } from "../../utils/math";
import api from "../../services/api";
import Navbar from "../../components/Navbar/Navbar";
import Subjects from "../../components/Subjects/Subjects";

const ChatShell = () => {
  const [conversations, setConversations] = useState([]);
  const { currentUser } = useContext(AuthContext);
  const [selectedConversation, setSelectedConversation] = useState(undefined);
  const [filteredConversations, setFilteredConversations] = useState([]);
  const [searchingTerm, setSearchingTerm] = useState("");
  const [showReplyView, setShowReplyView] = useState(false);
  const [targetToReply, setTargetToReply] = useState({});
  const [fileFromDrop, setFileFromDrop] = useState(null);
  const [showBio, setshowBio] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [communityList, setCommunityList] = useState([]);

  // Navbar controler
  const [isDashboard, setIsDashboard] = useState(false);
  const [isConversation, setIsConversation] = useState(true);
  const [isSubjects, setIsSubjects] = useState(false);
  const [navbarActive, setNavbarActive] = useState("conversation");

  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    if (currentUser.id) {
      setShowLoading(true)
      getMyCommunityAdms();
    }

    const unsubscribeChat = app
      .firestore()
      .collection("connections")
      .where("users", "array-contains", currentUser.id)
      .onSnapshot(async (_connections) => {
        let conn = _connections ? _connections.docs : [];
        let sortedConnections = [];
        conn = conn.filter(
          (item) =>
            (item.data().users && item.data().users.includes(currentUser.id)) ||
            (item.data().chatType === "GroupChat" &&
              !item.data().groupInfo.private)
        );
        conn = await flagBlockedUser(conn, currentUser.id);

        sortedConnections = sortConnections(conn);

        const connectionArray = sortedConnections.map((sortedConn) => {
          return { ...sortedConn.data(), id: sortedConn.ref.id };
        });

        setConversations(() => connectionArray);
        changeConversation(() => connectionArray[0]);
        // store.dispatch({
        //     type: 'CONVERSATIONS_LOADED',
        //     payload: {
        //         conversations,
        //     }
        // })
      });
    return () => unsubscribeChat();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser.id]);

  const getMyCommunityAdms = async () => {
    await api
      .get(`/getMyCommunityAdms/`, { params: { id: currentUser.id } })
      .then((res) => {
        setCommunityList(res.data);
        setShowLoading(false)
      })
      .catch((err) => {
        setShowLoading(false)
        console.log(err)
      });
  };

  const onDragEnter = useCallback((e) => {
    setIsVisible(true);
    e.stopPropagation();
    e.preventDefault();
    return false;
  }, []);
  const onDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }, []);
  const onDragLeave = useCallback((e) => {
    setIsVisible(false);
    e.stopPropagation();
    e.preventDefault();
    return false;
  }, []);
  const onDrop = useCallback((e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    setFileFromDrop(files[0] || []);
    setIsVisible(false);
    return false;
  }, []);

  useEffect(() => {
    if (window.document.getElementById("space-message") && !showBio) {
      window.document
        .getElementById("space-message")
        .addEventListener("dragleave", onDragLeave);
      window.document
        .getElementById("space-message")
        .addEventListener("dragenter", onDragEnter);
      window.document
        .getElementById("space-message")
        .addEventListener("dragover", onDragOver);
      window.document
        .getElementById("space-message")
        .addEventListener("drop", onDrop);
      return () => {
        if (window.document.getElementById("space-message")) {
          window.document
            .getElementById("space-message")
            .removeEventListener("dragleave", onDragLeave);
          window.document
            .getElementById("space-message")
            .removeEventListener("dragenter", onDragEnter);
          window.document
            .getElementById("space-message")
            .removeEventListener("dragover", onDragOver);
          window.document
            .getElementById("space-message")
            .removeEventListener("drop", onDrop);
        }
      };
    }
  }, [
    showBio,
    selectedConversation,
    onDragEnter,
    onDragLeave,
    onDragOver,
    onDrop,
  ]);
  
  function changeConversation(conversation) {
    setSelectedConversation(conversation);
    setshowBio(true);
  }
  
  async function flagBlockedUser(conn, userId) {
    let blockListByBlocked = await app
      .firestore()
      .collection("blocklist")
      .where("blockedAttenders", "array-contains", userId)
      .get();

    let hiddenBlockers = [];
    if (blockListByBlocked.docs.length > 0) {
      blockListByBlocked.docs.forEach((doc) => {
        conn.forEach((connection) => {
          if (connection.data().users.includes(doc.data().blockerId)) {
            hiddenBlockers.push(doc.data().blockerId);
          }
        });
      });
    }

    return conn.filter(
      (_conn) =>
        !hiddenBlockers.includes(
          _conn.data().users.filter((user) => user !== userId)[0]
        )
    );
  }
  function sortConnections(conn) {
    let sortedConnections = conn.sort((a, b) => {
      let alastMessage = a.data().lastMessage || {};
      let blastMessage = b.data().lastMessage || {};

      if (alastMessage.createdAt && blastMessage.createdAt) {
        return (
          blastMessage.createdAt.toDate() - alastMessage.createdAt.toDate()
        );
      } else if (alastMessage.createdAt && !blastMessage.createdAt) {
        return -1;
      } else if (!alastMessage.createdAt && blastMessage.createdAt) {
        return 1;
      }
      return 0;
    });
    return sortedConnections;
  }
  function searchingByTerm(term = "") {
    setSearchingTerm(term);
    if (term === "") {
      return true;
    }
    const filteredConversations = conversations.filter((conversation) => {
      let title;
      if (conversation.chatType === "GroupChat") {
        title = conversation.groupInfo.title;
      } else {
        let targetUser =
          conversation.sender === currentUser.id
            ? conversation.receiverUser
            : conversation.senderUser;

        title = `${targetUser.firstName} ${targetUser.lastName}`;
      }
      if (title.trim().toLowerCase().includes(term.toLowerCase())) {
        return true;
      }

      if (
        conversation.lastMessage &&
        conversation.lastMessage.text
          .trim()
          .toLowerCase()
          .includes(term.toLowerCase())
      ) {
        return true;
      }
      return false;
    });
    setFilteredConversations(filteredConversations);
  }

  function _displayReplyView(show, data) {
    setShowReplyView(show);
    setTargetToReply(data);
  }

  async function sendMessage(targertUserId) {
    let targetUser = await app
      .firestore()
      .collection("users")
      .doc(targertUserId)
      .get();

    targetUser = targetUser.data();

    let alreadyConnected = await app
      .firestore()
      .collection("connections")
      .where("users", "array-contains", currentUser.id)
      .get();

    alreadyConnected = alreadyConnected.docs.find((connection) => {
      return (
        connection.data().chatType !== "GroupChat" &&
        connection.data().users.includes(targertUserId)
      );
    });

    if (alreadyConnected === undefined) {
      let conversationData = {
        sender: currentUser.id,
        receiver: targertUserId,
        accepted: true,
        eventId: selectedConversation.eventId,
        senderUser: {
          firstName: currentUser.firstName,
          lastName: currentUser.lastName,
          photoURL: currentUser.photoURL,
        },
        senderProject: {},
        receiverUser: {
          firstName: targetUser.firstName,
          lastName: targetUser.lastName,
          photoURL: targetUser.photoURL,
        },
        receiverProject: {},
        users: [currentUser.id, targertUserId],
      };
      changeConversation({
        ...conversationData,
        id: generateUniqueFirestoreId(),
      });
    } else {
      changeConversation({
        ...alreadyConnected.data(),
        id: alreadyConnected.id,
      });
    }
  }
  async function sendGroupMessage(groupId) {
    let alreadyConnected = await app
      .firestore()
      .collection("connections")
      .doc(groupId)
      .get();

    changeConversation({
      ...alreadyConnected.data(),
      id: alreadyConnected.id,
    });
  }
  function changeNavbarState(barName) {
    switch (barName) {
      case "conversation":
        setIsConversation(true);
        setIsDashboard(false);
        setIsSubjects(false);
        setNavbarActive("conversation");
        break;

      case "dashboard":
        setIsConversation(false);
        setIsDashboard(true);
        setshowBio(false);
        setIsSubjects(false);
        setNavbarActive("dashboard");

        break;

        case "subjects":
          setIsConversation(false);
          setIsDashboard(false);
          setshowBio(false);
          setIsSubjects(true);
          setNavbarActive("subjects");
  
        break;

      default:
        break;
    }
  }

  let conversationContent = (
    <>
      <NoConversations></NoConversations>
    </>
  );

  if (conversations.length > 0 && selectedConversation) {
    conversationContent = (
      <MessageList
        displayReplyView={_displayReplyView}
        targetToReply={targetToReply}
        conversationId={selectedConversation.id}
        users={selectedConversation.users}
        moderator={selectedConversation.moderator || []}
        eventId={selectedConversation.eventId}
        chatType={selectedConversation.chatType}
        setSelectedConversation={changeConversation}
        sendMessage={sendMessage}
        selectedConversation={selectedConversation}
        showBio={showBio}
      />
    );
  }

  return (
    <div id={`chat-container${      
      navbarActive === 'conversation' && showBio ? "-bio" :
      navbarActive === 'dashboard' || 'subjects' ? "-dashboard": ""
    }`}>
      {showLoading && <div class="loader" />}   
      <Navbar
        profileImage={currentUser.photoURL}
        changeNavbarState={changeNavbarState}
        navbarActive={navbarActive}
        dashboardActive={ communityList.length > 0 }
      />

      {
        isDashboard && 
          <Dashboard
            communityList={communityList}
          />
      }

{
        isSubjects && 
          <Subjects
            communityList={communityList}
          />
      }

      {isConversation && (
        <>
          <ConversationSearch searchingByTerm={searchingByTerm} />
          <ConversationList
            conversations={
              searchingTerm.length > 0 ? filteredConversations : conversations
            }
            selectedConversation={selectedConversation}
            setSelectedConversation={changeConversation}
            showBio={showBio}
          />
          <ChatTitle
            selectedConversation={selectedConversation}
            setOpenbio={setshowBio}
          />

          <div id="space-message">
            {isVisible && !showBio ? (
              <>
                {selectedConversation && (
                  <div
                    id="drop"
                    onMouseLeave={() => {
                      setIsVisible(false);
                    }}
                  >
                    <div>soltar o arquivo aqui </div>
                  </div>
                )}
              </>
            ) : (
              <>
                {conversationContent}
                <ChatForm
                  setFileFromDrop={setFileFromDrop}
                  fileFromDrop={fileFromDrop}
                  targetToReply={targetToReply}
                  displayReplyView={_displayReplyView}
                  showReplyView={showReplyView}
                  selectedConversation={selectedConversation}
                />
              </>
            )}
          </div>
          {showBio ? (
            <ChatBio
              selectedConversation={selectedConversation}
              closedBio={() => setshowBio(false)}
              currentUser={currentUser}
              setSelectedConversation={changeConversation}
              eventId={selectedConversation.eventId}
              sendMessage={sendMessage}
              sendGroupMessage={sendGroupMessage}
              showBio={showBio}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default ChatShell;
